<template>
  <div class="container" style="text-align:justify;">
    <div class="row">
      <div class="col">
        <br />
        <h3 style="text-align:center;">How {{ fgTitle }} Works</h3>
        <br />
        <p class="mb-1">
          Data shows us that our educators are spending $500 per year out of
          their own pockets to fund their classrooms. A better and less costly
          solution for our educators is to apply for simple education grants.
          Does grant writing seem intimidating or time consuming? Don’t worry,
          Funds Granted simplifies the finding, writing, and application
          process. We’ve created an online platform that allows teachers,
          administrators, and staff members to easily apply for funding
          opportunities that have been personally matched to them based on their
          funding needs. The flowchart highlights software features. Briefly,
          educators can set up personal profiles to indicate funding
          preferences, browse applicable grants, save and share grant
          opportunities, utilize templates to complete application responses,
          and stay on task through calendars and notifications. We also offer a
          live chat tool, training, tutorials, and blog. New grant writing
          tutorials and a mobile app will be developed this summer and released
          for the upcoming school year.
        </p>
        <p>
          Thousands of funding opportunities are available for our educators and
          we want to bring that funding into our schools to enhance learning
          experiences for everyone from the administrator to the students. We
          know grants can seem intimidating and time consuming, but we have
          created Funds Granted to simplify this process and help educators
          realize that applying for grants is not only manageable, but
          profitable.
        </p>
        <img
          src="@/assets/Funds Granted Flow Chart.svg"
          width="auto"
          height="auto"
          alt="icon"
        />
      </div>
    </div>
    <div class="text-center">
      <router-link to="tryforfree" class="btn btn-primary"
        >Try For Free!</router-link
      >
    </div>
  </div>
</template>

<script>
import { nittyGritty } from "@/constants/NittyGritty.js";

export default {
  name: "WhyUs",
  data() {
    return {
      fgTitle: nittyGritty.fundsGrantedTitle
    };
  },
  methods: {
    method() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
